import { CloseOption, IconCancelarBaixa } from '../../assets/icons/closeOption'
import { HistoryIcon } from '../../assets/icons/history'
import { usePredictionDetails } from '../../pages/PredictionDetails/usePredictionDetails'
import { colors } from '../../theme'
import { CardIconTitle } from '../CardIconTitle/CardIconTitle'
import { GenericTable } from '../GenericTable/GenericTable'
import { Loading } from '../Loading/Loading'
import { PaginationHistoryPredict } from '../Pagination/Pagination'
// import { Loading } from '../Loading/Loading'
import {
  ContainerModalSend,
  ContainerTable,
  DivImg,
  Closed,
  SendStyle,
  CancelarBaixa,
} from './styles'

type ProductDetailsPredictionsProps = {
  handleIsHistoricoBaixa: () => void
}

export function HistoricoDeBaixas({
  handleIsHistoricoBaixa,
}: ProductDetailsPredictionsProps) {
  const {
    isLoadingHistoryBaixa,
    predictionHistoryBaixa,
    currentPagesHistoryBaixa,
    setCurrentHistoryBaixa,
    cancelaUmaBaixa,
  } = usePredictionDetails()

  return (
    <ContainerModalSend>
      <SendStyle>
        <DivImg>
          <CardIconTitle
            icon={<HistoryIcon />}
            background={colors.grey200}
            title="Histórico de baixas"
            color={colors.grey900}
          />
          <Closed
            onClick={() => {
              handleIsHistoricoBaixa()
            }}
          >
            <CloseOption />
          </Closed>
        </DivImg>

        <ContainerTable>
          <GenericTable
            font="14px"
            spacing="20px"
            headers={[
              // 'ID',
              'Produto',
              // 'Última compra',
              'Próx. compra',
              // 'Qtd.',
              'Cancelar Baixa',
            ]}
          >
            {isLoadingHistoryBaixa ? (
              <Loading contrast={false} />
            ) : (
              predictionHistoryBaixa.content &&
              Array.isArray(predictionHistoryBaixa.content) &&
              predictionHistoryBaixa.content.map(item => (
                // historico.map(item => (

                <tr id="darBaixa" key={item.id}>
                  {/* <td>{item.id}</td> */}
                  <td className="colPredictionDetails">{item.nome}</td>
                  {/* <td className="col3">{item.ultimaCompra}</td> */}
                  <td className="col3">{item.proximaCompra}</td>
                  {/* <td className="colVendas">{item.quantidade}</td> */}
                  {/* <td className="colVendas6">{item.quantidade}</td> */}
                  <td className="colVendas6">
                    <CancelarBaixa
                      onClick={() => {
                        cancelaUmaBaixa(item.id, item.proximaCompra)
                      }}
                    >
                      <IconCancelarBaixa />
                    </CancelarBaixa>
                  </td>
                </tr>
              ))
            )}
          </GenericTable>
          <PaginationHistoryPredict
            pageNumber={currentPagesHistoryBaixa}
            pageSize={predictionHistoryBaixa.totalElements}
            offSet={predictionHistoryBaixa.size}
            onClick={page => setCurrentHistoryBaixa(page)}
          />
        </ContainerTable>
      </SendStyle>
    </ContainerModalSend>
  )
}
